import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIRouterModule } from '@uirouter/angular';
import { CoreModule, ModalPanelComponent } from '@tdwb/core';
import { AgreementsService, Agreement, AgreementType, AgreementStatus } from '@tdwb/lazy/platform/preferences';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';
import { PlatformCommonModule } from '../common/platform-common.module';
import { OldAgreementsModule } from './old-agreements/old-agreements.module';
import { CurrentAgreementsModule } from './current-agreements/current-agreements.module';
import { AgreementsFinePrintComponent } from './agreements-fine-print.component';
import { AgreementsRoutes } from './agreements.routes';
import { AgreementsCegFinePrintComponent } from './agreements-ceg-fine-print.component';
import { AgreementsNyseFinePrintComponent } from './agreements-nyse-fine-print.component';
import { AgreementsNasdaqFinePrintComponent } from './agreements-nasdaq-fine-print.component';
import { UnsignedAgreementsComponent } from './unsigned-agreements.component';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    WebbrokerCoreModule,
    TranslateModule.forChild(),
    OldAgreementsModule,
    CurrentAgreementsModule,
    PlatformCommonModule,
    UIRouterModule.forChild({
      states: AgreementsRoutes.states
    }),
    ModalPanelComponent
  ],
  exports: [
    AgreementsFinePrintComponent,
    OldAgreementsModule,
    CurrentAgreementsModule
  ],
  declarations: [
    AgreementsFinePrintComponent,
    AgreementsCegFinePrintComponent,
    AgreementsNasdaqFinePrintComponent,
    AgreementsNyseFinePrintComponent,
    UnsignedAgreementsComponent
  ]
})
export class AgreementsModule {
}

export {
  AgreementsFinePrintComponent,
  AgreementsService,
  OldAgreementsModule,
  CurrentAgreementsModule,
  Agreement,
  AgreementType,
  AgreementStatus,
  UnsignedAgreementsComponent
};
